import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/products', { params })
  },
  store (formData) {
    return apiClient.post('/products', formData)
  },
  show (id, params) {
    return apiClient.get(`/products/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/products/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/products/${id}`)
  }
}
